import Component from './lottery_page_win.vue'
export default Component
